import {InternshipCompanyContact, InternshipCompanyContactPayload} from './internship-company-contact'

export interface InternshipCompanyPayload {
    id: number
    firma: string
    branche: string
    fachrichtung: string
    adresse: string
    plz: string
    ort: string
    stellen: number
    /* relations */
    contacts?: InternshipCompanyContactPayload[]
}

export class InternshipCompany {

    id: number
    firma: string
    branche: string
    fachrichtung: string
    adresse: string
    plz: string
    ort: string
    stellen: number
    /* relations */
    contacts: InternshipCompanyContact[]

    constructor(data: InternshipCompanyPayload) {
        this.id = data.id
        this.firma = data.firma
        this.branche = data.branche
        this.fachrichtung = data.fachrichtung
        this.adresse = data.adresse
        this.plz = data.plz
        this.ort = data.ort
        this.stellen = data.stellen
        this.contacts = [] as InternshipCompanyContact[]
        data.contacts?.forEach((item: InternshipCompanyContactPayload) => {
            this.contacts.push(new InternshipCompanyContact(item))
        })
    }

    fill(data: InternshipCompanyPayload): this {
        this.id = data.id
        this.firma = data.firma
        this.branche = data.branche
        this.fachrichtung = data.fachrichtung
        this.adresse = data.adresse
        this.plz = data.plz
        this.ort = data.ort
        this.stellen = data.stellen
        this.contacts = [] as InternshipCompanyContact[]
        data.contacts?.forEach((item: InternshipCompanyContactPayload) => {
            this.contacts.push(new InternshipCompanyContact(item))
        })
        return this
    }

    payload(): InternshipCompanyPayload {
        return {
            id: this.id,
            firma: this.firma,
            branche: this.branche,
            fachrichtung: this.fachrichtung,
            adresse: this.adresse,
            plz: this.plz,
            ort: this.ort,
            stellen: this.stellen,
        }
    }
}
